/* @flow */

import {MIN_SEARCH_LENGTH} from '../../consts';

import {FIELD_NAME, FIELD_EMAIL, FIELD_PHONE, FIELD_DESCRIPTION, FIELD_ROLE} from './consts';
import {type ContactFormFieldTypes} from './types';

export const shouldShowPotentialContacts = (
    name: ?string,
    description: ?string,
    phoneNumber: ?string,
    email: ?string,
    hasRelatedAccounts: boolean
) => {
    return (
        hasRelatedAccounts ||
        (name && name.length >= MIN_SEARCH_LENGTH) ||
        (description && description.length >= MIN_SEARCH_LENGTH) ||
        (phoneNumber && phoneNumber.length >= MIN_SEARCH_LENGTH) ||
        (email && email.length >= MIN_SEARCH_LENGTH)
    );
};

export const shouldAllowCreate = (
    isTemporary: boolean,
    name: ?string,
    phoneNumber: ?string,
    email: ?string
) => {
    return (
        !isTemporary &&
        ((name && name.length >= MIN_SEARCH_LENGTH) ||
            (phoneNumber && phoneNumber.length >= MIN_SEARCH_LENGTH) ||
            (email && email.length >= MIN_SEARCH_LENGTH))
    );
};

export const handleKeyboardNavigation = (
    e: SyntheticKeyboardEvent<>,
    hasContactParentAccount: boolean,
    currentField: ContactFormFieldTypes,
    emailRef: React.Ref<?HTMLInputElement | null>,
    phoneRef: React.Ref<?HTMLInputElement | null>,
    descriptionRef: React.Ref<?HTMLInputElement | null>,
    roleRef: React.Ref<?HTMLInputElement | null>,
    nameRef: React.Ref<?HTMLInputElement | null>
) => {
    switch (e.key) {
        case 'ArrowDown':
            if (currentField === FIELD_NAME)
                descriptionRef.current && descriptionRef.current.focus();
            if (currentField === FIELD_DESCRIPTION) {
                if (hasContactParentAccount) {
                    roleRef.current && roleRef.current.focus();
                } else {
                    phoneRef.current && phoneRef.current.focus();
                }
            }
            if (currentField === FIELD_ROLE) phoneRef.current && phoneRef.current.focus();
            if (currentField === FIELD_PHONE) emailRef.current && emailRef.current.focus();
            if (currentField === FIELD_EMAIL) nameRef.current && nameRef.current.focus();

            break;
        case 'ArrowUp':
            if (currentField === FIELD_NAME) emailRef.current && emailRef.current.focus();
            if (currentField === FIELD_DESCRIPTION) nameRef.current && nameRef.current.focus();
            if (currentField === FIELD_ROLE)
                descriptionRef.current && descriptionRef.current.focus();
            if (currentField === FIELD_PHONE) {
                if (hasContactParentAccount) {
                    roleRef.current && roleRef.current.focus();
                } else {
                    descriptionRef.current && descriptionRef.current.focus();
                }
            }
            if (currentField === FIELD_EMAIL) phoneRef.current && phoneRef.current.focus();

            break;
    }
};
